import { useEffect, useState } from 'react';
import { useRxCollection } from 'rxdb-hooks';

import { RxdbCollectionName } from '../rxdbCollectionName';
import { EquipmentTypeCollection, EquipmentTypeDocument } from './queryBuilder';

export const useEquipmentType = () => {
  const equipmentTypeCollection: EquipmentTypeCollection = useRxCollection(
    RxdbCollectionName.EQUIPMENT_TYPE,
  );

  const [equipmentTypesInitialized, setCollectionsInitialized] = useState(false);

  useEffect(() => {
    if (equipmentTypeCollection) setCollectionsInitialized(true);
  }, [equipmentTypeCollection]);

  const listEquipmentType = async (): Promise<EquipmentTypeDocument[]> => {
    if (!equipmentTypeCollection) {
      return [];
    }
    try {
      const types = await equipmentTypeCollection.find().exec();
      return types;
    } catch (error) {
      console.log('🚀 ~ file: useEquipmentType.ts ~ line 28 ~ listEquipmentType ~ error', error);
      throw error;
    }
  };

  return { listEquipmentType, equipmentTypesInitialized };
};

export default useEquipmentType;
